var Curriculog = Curriculog || {};

Curriculog.Roles = (function ($, _, Backbone, Roles) {

	Roles = Curriculog.CurriculogCollection.extend({
		url: '/rest/role',
		model: Curriculog.Role,

		comparator: function (a, b) {
			if (a.get('name').toLowerCase() < b.get('name').toLowerCase())
				return -1;
			if (a.get('name').toLowerCase() > b.get('name').toLowerCase())
				return 1;
			else return 0;
		},

		getRoleModelsForEntity: function (entityID) {
			return this.filter(function (model) {
				return model.get('entity_id') === entityID;
			});
		},

		getRoleObjectsForEntity: function (entityID) {
			var roles = this.getRoleModelsForEntity(entityID);
			return roles.map(function (item) {
				return item.toJSON();
			});
		},

		getRoleTypeIDsForEntity: function (entityID) {
			var roles = this.getRoleModelsForEntity(entityID);
			return roles.map(function (item) {
				return item.get('role_type_id');
			});
		},

		getManyRoles: function (roleIDList) {
			var that = this;
			var roles = [];
			roleIDList.forEach(function (item, index) {
				var role = that.get(item);
				if (typeof role !== 'undefined'){
					roles.push(role);
				}
			});
			return roles;
		},

		getManyRoleObjects: function (roleIDList) {
			var roles = this.getManyRoles(roleIDList);
			return roles.map(function (item) {
				return item.toJSON();
			});
		},

		getRolesByCommittee: function (committeeID) {
			var roles = [];
			for (var i=0; i < this.length; i++) {
				var role = this.at(i);

				if (role.get('committee_id') === committeeID) {
					roles.push(entity);
				}
			}
			return roles;
		},
	});
	return Roles;

})($, _, Backbone, Curriculog.Roles || {});